import 'css-chunk:src/app/containers/Home/OrganizationsView/ClientGroup/ClientGroupListView.scss';export default {
  "ClientGroupListView": "_ClientGroupListView_13zht_2",
  "header": "_header_13zht_2",
  "deleteButton": "_deleteButton_13zht_7",
  "createButton": "_createButton_13zht_10",
  "table": "_table_13zht_13",
  "idCell": "_idCell_13zht_13"
};